'use client'

import PaginationNew from '@component/pagination/new'
import useProgressRouter from '@hooks/useProgressRouter'
import getHouseRoute from '@plugin/searchRoute/modules/house'
import { houseList } from '@router'
import { useCallback, useMemo } from 'react'

export default function SearchListPagination({
  pageIndex,
  state,
  totals,
  preload = false
}) {

  const { replaceRouter } = useProgressRouter()
  const { pageSize, type, slug, searchParams } = state

  const changeHandle = useCallback(idx => {
    replaceRouter(getUrl(type, slug, searchParams, idx))
  }, [slug, type, searchParams, replaceRouter])

  const paginationUrl = useMemo(() => getUrl(type, slug, searchParams, '{page}'), [type, slug, searchParams])
  return totals > 0 && (
    <PaginationNew pageIndex={pageIndex} center preload={preload} pageSize={pageSize} totals={totals} url={paginationUrl} onChange={changeHandle}></PaginationNew>
  )
}

function getUrl(type, slug, searchParams, page) {
  const houseRoute = getHouseRoute()
  houseRoute.fromSlug(slug)
  houseRoute.page = page
  return houseList(type, houseRoute.toSlug(), searchParams)
}